module.exports = __webpack_public_path__ + "img/reel1.aa7c37cd.webp";